// Normalises Axios/FastAPI error payloads into a safe display string.
// FastAPI validation errors return `detail` as an array of objects, which
// must never be passed directly to a React child / toast.
export const errMsg = (e, fallback = "Something went wrong") => {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d.map((x) => x?.msg || (typeof x === "string" ? x : JSON.stringify(x))).join(", ");
  }
  if (typeof d === "object") return d.msg || JSON.stringify(d);
  return String(d);
};
